export const customPeoples = [
  {data: "😀", category: "Peoples", aliases: ["grinning"]},
  {data: "😃", category: "Peoples", aliases: ["smiley"]},
  {data: "😄", category: "Peoples", aliases: ["smile"]},
  {data: "😁", category: "Peoples", aliases: ["grin"]},
  {data: "😆", category: "Peoples", aliases: ["laughing", "satisfied"]},
  {data: "😅", category: "Peoples", aliases: ["sweat_smile"]},
  {data: "😂", category: "Peoples", aliases: ["joy"]},
  {data: "🤣", category: "Peoples", aliases: ["rofl"]},
  {data: "😌", category: "Peoples", aliases: ["relaxed"]},
  {data: "😊", category: "Peoples", aliases: ["blush"]},
  {data: "😇", category: "Peoples", aliases: ["innocent"]},
  {data: "🙂", category: "Peoples", aliases: ["slightly_smiling_face"]},
  {data: "🙃", category: "Peoples", aliases: ["upside_down_face"]},
  {data: "😉", category: "Peoples", aliases: ["wink"]},
  {data: "😌", category: "Peoples", aliases: ["relieved"]},
  {data: "😍", category: "Peoples", aliases: ["heart_eyes"]},
  {data: "😘", category: "Peoples", aliases: ["kissing_heart"]},
  {data: "😗", category: "Peoples", aliases: ["kissing"]},
  {data: "😙", category: "Peoples", aliases: ["kissing_smiling_eyes"]},
  {data: "😚", category: "Peoples", aliases: ["kissing_closed_eyes"]},
  {data: "😋", category: "Peoples", aliases: ["yum"]},
  {data: "😜", category: "Peoples", aliases: ["stuck_out_tongue_winking_eye"]},
  {data: "😝", category: "Peoples", aliases: ["stuck_out_tongue_closed_eyes"]},
  {data: "😛", category: "Peoples", aliases: ["stuck_out_tongue"]},
  {data: "🤗", category: "Peoples", aliases: ["hugs"]},
  {data: "🤓", category: "Peoples", aliases: ["nerd_face"]},
  {data: "😎", category: "Peoples", aliases: ["sunglasses"]},
  {data: "😏", category: "Peoples", aliases: ["smirk"]},
  {data: "😒", category: "Peoples", aliases: ["unamused"]},
  {data: "😞", category: "Peoples", aliases: ["disappointed"]},
  {data: "😔", category: "Peoples", aliases: ["pensive"]},
  {data: "😟", category: "Peoples", aliases: ["worried"]},
  {data: "😕", category: "Peoples", aliases: ["confused"]},
  {data: "🙁", category: "Peoples", aliases: ["slightly_frowning_face"]},
  {data: "☹️", category: "Peoples", aliases: ["frowning_face"]},
  {data: "😣", category: "Peoples", aliases: ["persevere"]},
  {data: "😖", category: "Peoples", aliases: ["confounded"]},
  {data: "😫", category: "Peoples", aliases: ["tired_face"]},
  {data: "😩", category: "Peoples", aliases: ["weary"]},
  {data: "😤", category: "Peoples", aliases: ["triumph"]},
  {data: "😠", category: "Peoples", aliases: ["angry"]},
  {data: "😡", category: "Peoples", aliases: ["rage", "pout"]},
  {data: "😶", category: "Peoples", aliases: ["no_mouth"]},
  {data: "😐", category: "Peoples", aliases: ["neutral_face"]},
  {data: "😑", category: "Peoples", aliases: ["expressionless"]},
  {data: "😯", category: "Peoples", aliases: ["hushed"]},
  {data: "😦", category: "Peoples", aliases: ["frowning"]},
  {data: "😧", category: "Peoples", aliases: ["anguished"]},
  {data: "😮", category: "Peoples", aliases: ["open_mouth"]},
  {data: "😲", category: "Peoples", aliases: ["astonished"]},
  {data: "😵", category: "Peoples", aliases: ["dizzy_face"]},
  {data: "😳", category: "Peoples", aliases: ["flushed"]},
  {data: "😱", category: "Peoples", aliases: ["scream"]},
  {data: "😨", category: "Peoples", aliases: ["fearful"]},
  {data: "😰", category: "Peoples", aliases: ["cold_sweat"]},
  {data: "😢", category: "Peoples", aliases: ["cry"]},
  {data: "😥", category: "Peoples", aliases: ["disappointed_relieved"]},
  {data: "🤤", category: "Peoples", aliases: ["drooling_face"]},
  {data: "😭", category: "Peoples", aliases: ["sob"]},
  {data: "😓", category: "Peoples", aliases: ["sweat"]},
  {data: "😪", category: "Peoples", aliases: ["sleepy"]},
  {data: "😴", category: "Peoples", aliases: ["sleeping"]},
  {data: "🙄", category: "Peoples", aliases: ["roll_eyes"]},
  {data: "🤔", category: "Peoples", aliases: ["thinking"]},
  {data: "🤥", category: "Peoples", aliases: ["lying_face"]},
  {data: "😬", category: "Peoples", aliases: ["grimacing"]},
  {data: "🤐", category: "Peoples", aliases: ["zipper_mouth_face"]},
  {data: "🤢", category: "Peoples", aliases: ["nauseated_face"]},
  {data: "🤧", category: "Peoples", aliases: ["sneezing_face"]},
  {data: "😷", category: "Peoples", aliases: ["mask"]},
  {data: "🤒", category: "Peoples", aliases: ["face_with_thermometer"]},
  {data: "🤕", category: "Peoples", aliases: ["face_with_head_bandage"]},
  {data: "😈", category: "Peoples", aliases: ["smiling_imp"]},
  {data: "👿", category: "Peoples", aliases: ["imp"]},
  {data: "👹", category: "Peoples", aliases: ["japanese_ogre"]},
  {data: "👺", category: "Peoples", aliases: ["japanese_goblin"]},
  {data: "💩", category: "Peoples", aliases: ["hankey", "poop", "shit"]},
  {data: "👻", category: "Peoples", aliases: ["ghost"]},
  {data: "💀", category: "Peoples", aliases: ["skull"]},
  {data: "☠️", category: "Peoples", aliases: ["skull_and_crossbones"]},
  {data: "👽", category: "Peoples", aliases: ["alien"]},
  {data: "👾", category: "Peoples", aliases: ["space_invader"]},
  {data: "👐", category: "Peoples", aliases: ["open_hands"]},
  {data: "🙌", category: "Peoples", aliases: ["raised_hands"]},
  {data: "👏", category: "Peoples", aliases: ["clap"]},
  {data: "🙏", category: "Peoples", aliases: ["pray"]},
  {data: "🤝", category: "Peoples", aliases: ["handshake"]},
  {data: "👍", category: "Peoples", aliases: ["+1", "thumbsup"]},
  {data: "🤛", category: "Peoples", aliases: ["fist_left"]},
  {data: "🤜", category: "Peoples", aliases: ["fist_right"]},
  {data: "🤞", category: "Peoples", aliases: ["crossed_fingers"]},
  {data: "✌️", category: "Peoples", aliases: ["v"]},
  {data: "🤘", category: "Peoples", aliases: ["metal"]},
  {data: "👌", category: "Peoples", aliases: ["ok_hand"]},
  {data: "👈", category: "Peoples", aliases: ["point_left"]},
  {data: "👉", category: "Peoples", aliases: ["point_right"]},
  {data: "👆", category: "Peoples", aliases: ["point_up_2"]},
  {data: "👇", category: "Peoples", aliases: ["point_down"]},
  {data: "☝️", category: "Peoples", aliases: ["point_up"]},
  {data: "✋", category: "Peoples", aliases: ["hand", "raised_hand"]},
  {data: "🤚", category: "Peoples", aliases: ["raised_back_of_hand"]},
  {data: "🖐", category: "Peoples", aliases: ["raised_hand_with_fingers_splayed"]},
  {data: "🖖", category: "Peoples", aliases: ["vulcan_salute"]},
  {data: "👋", category: "Peoples", aliases: ["wave"]},
  {data: "🤙", category: "Peoples", aliases: ["call_me_hand"]},
  {data: "💪", category: "Peoples", aliases: ["muscle"]},
  {data: "✍️", category: "Peoples", aliases: ["writing_hand"]},
  {data: "🤳", category: "Peoples", aliases: ["selfie"]},
  {data: "💅", category: "Peoples", aliases: ["nail_care"]},
  {data: "💍", category: "Peoples", aliases: ["ring"]},
  {data: "💄", category: "Peoples", aliases: ["lipstick"]},
  {data: "💋", category: "Peoples", aliases: ["kiss"]},
  {data: "👄", category: "Peoples", aliases: ["lips"]},
  {data: "👅", category: "Peoples", aliases: ["tongue"]},
  {data: "👂", category: "Peoples", aliases: ["ear"]},
  {data: "👃", category: "Peoples", aliases: ["nose"]},
  {data: "👣", category: "Peoples", aliases: ["footprints"]},
  {data: "👁", category: "Peoples", aliases: ["eye"]},
  {data: "👀", category: "Peoples", aliases: ["eyes"]},
  {data: "🗣", category: "Peoples", aliases: ["speaking_head"]},
  {data: "👤", category: "Peoples", aliases: ["bust_in_silhouette"]},
  {data: "👥", category: "Peoples", aliases: ["busts_in_silhouette"]},
  {data: "👶", category: "Peoples", aliases: ["baby"]},
  {data: "👦", category: "Peoples", aliases: ["boy"]},
  {data: "👧", category: "Peoples", aliases: ["girl"]},
  {data: "👨", category: "Peoples", aliases: ["man"]},
  {data: "👩", category: "Peoples", aliases: ["woman"]},
  {data: "👱‍♀", category: "Peoples", aliases: ["blonde_woman"]},
  {data: "👱", category: "Peoples", aliases: ["blonde_man", "person_with_blond_hair"]},
  {data: "👴", category: "Peoples", aliases: ["older_man"]},
  {data: "👵", category: "Peoples", aliases: ["older_woman"]},
  {data: "👲", category: "Peoples", aliases: ["man_with_gua_pi_mao"]},
  {data: "👳‍♀", category: "Peoples", aliases: ["woman_with_turban"]},
  {data: "👳", category: "Peoples", aliases: ["man_with_turban"]},
  {data: "👮‍♀", category: "Peoples", aliases: ["policewoman"]},
  {data: "👮", category: "Peoples", aliases: ["policeman", "cop"]},
  {data: "👷‍♀", category: "Peoples", aliases: ["construction_worker_woman"]},
  {data: "👷", category: "Peoples", aliases: ["construction_worker_man", "construction_worker"]},
  {data: "💂‍♀", category: "Peoples", aliases: ["guardswoman"]},
  {data: "💂", category: "Peoples", aliases: ["guardsman"]},
  {data: "👩‍⚕", category: "Peoples", aliases: ["woman_health_worker"]},
  {data: "👨‍⚕", category: "Peoples", aliases: ["man_health_worker"]},
  {data: "👩‍🌾", category: "Peoples", aliases: ["woman_farmer"]},
  {data: "👨‍🌾", category: "Peoples", aliases: ["man_farmer"]},
  {data: "👩‍🍳", category: "Peoples", aliases: ["woman_cook"]},
  {data: "👨‍🍳", category: "Peoples", aliases: ["man_cook"]},
  {data: "👩‍🎓", category: "Peoples", aliases: ["woman_student"]},
  {data: "👨‍🎓", category: "Peoples", aliases: ["man_student"]},
  {data: "👩‍🎤", category: "Peoples", aliases: ["woman_singer"]},
  {data: "👨‍🎤", category: "Peoples", aliases: ["man_singer"]},
  {data: "👩‍🏫", category: "Peoples", aliases: ["woman_teacher"]},
  {data: "👨‍🏫", category: "Peoples", aliases: ["man_teacher"]},
  {data: "👩‍🏭", category: "Peoples", aliases: ["woman_factory_worker"]},
  {data: "👨‍🏭", category: "Peoples", aliases: ["man_factory_worker"]},
  {data: "👩‍💻", category: "Peoples", aliases: ["woman_technologist"]},
  {data: "👨‍💻", category: "Peoples", aliases: ["man_technologist"]},
  {data: "👩‍💼", category: "Peoples", aliases: ["woman_office_worker"]},
  {data: "👨‍💼", category: "Peoples", aliases: ["man_office_worker"]},
  {data: "👩‍🔧", category: "Peoples", aliases: ["woman_mechanic"]},
  {data: "👨‍🔧", category: "Peoples", aliases: ["man_mechanic"]},
  {data: "👩‍🔬", category: "Peoples", aliases: ["woman_scientist"]},
  {data: "👨‍🔬", category: "Peoples", aliases: ["man_scientist"]},
  {data: "👩‍🎨", category: "Peoples", aliases: ["woman_artist"]},
  {data: "👨‍🎨", category: "Peoples", aliases: ["man_artist"]},
  {data: "👩‍🚒", category: "Peoples", aliases: ["woman_firefighter"]},
  {data: "👨‍🚒", category: "Peoples", aliases: ["man_firefighter"]},
  {data: "👩‍🚀", category: "Peoples", aliases: ["woman_astronaut"]},
  {data: "👨‍🚀", category: "Peoples", aliases: ["man_astronaut"]},
  {data: "🤶", category: "Peoples", aliases: ["mrs_claus"]},
  {data: "🎅", category: "Peoples", aliases: ["santa"]},
  {data: "👸", category: "Peoples", aliases: ["princess"]},
  {data: "🤴", category: "Peoples", aliases: ["prince"]},
  {data: "👰", category: "Peoples", aliases: ["bride_with_veil"]},
  {data: "🤵", category: "Peoples", aliases: ["man_in_tuxedo"]},
  {data: "👼", category: "Peoples", aliases: ["angel"]},
  {data: "🤰", category: "Peoples", aliases: ["pregnant_woman"]},
  {data: "🙇‍♀", category: "Peoples", aliases: ["bowing_woman"]},
  {data: "🙇", category: "Peoples", aliases: ["bowing_man", "bow"]},
  {data: "💁", category: "Peoples", aliases: ["tipping_hand_woman", "information_desk_person", "sassy_woman"]},
  {data: "💁‍♂", category: "Peoples", aliases: ["tipping_hand_man", "sassy_man"]},
  {data: "🙅", category: "Peoples", aliases: ["no_good_woman", "no_good", "ng_woman"]},
  {data: "🙅‍♂", category: "Peoples", aliases: ["no_good_man", "ng_man"]},
  {data: "🙆", category: "Peoples", aliases: ["ok_woman"]},
  {data: "🙆‍♂", category: "Peoples", aliases: ["ok_man"]},
  {data: "🙋", category: "Peoples", aliases: ["raising_hand_woman", "raising_hand"]},
  {data: "🙋‍♂", category: "Peoples", aliases: ["raising_hand_man"]},
  {data: "🤦‍♀", category: "Peoples", aliases: ["woman_facepalming"]},
  {data: "🤦‍♂", category: "Peoples", aliases: ["man_facepalming"]},
  {data: "🤷‍♀", category: "Peoples", aliases: ["woman_shrugging"]},
  {data: "🤷‍♂", category: "Peoples", aliases: ["man_shrugging"]},
  {data: "🙎", category: "Peoples", aliases: ["pouting_woman", "person_with_pouting_face"]},
  {data: "🙎‍♂", category: "Peoples", aliases: ["pouting_man"]},
  {data: "🙍", category: "Peoples", aliases: ["frowning_woman", "person_frowning"]},
  {data: "🙍‍♂", category: "Peoples", aliases: ["frowning_man"]},
  {data: "💇", category: "Peoples", aliases: ["haircut_woman", "haircut"]},
  {data: "💇‍♂", category: "Peoples", aliases: ["haircut_man"]},
  {data: "💆", category: "Peoples", aliases: ["massage_woman", "massage"]},
  {data: "💆‍♂", category: "Peoples", aliases: ["massage_man"]},
  {data: "🕴", category: "Peoples", aliases: ["business_suit_levitating"]},
  {data: "💃", category: "Peoples", aliases: ["dancer"]},
  {data: "🕺", category: "Peoples", aliases: ["man_dancing"]},
  {data: "👯", category: "Peoples", aliases: ["dancing_women", "dancers"]},
  {data: "👯‍♂", category: "Peoples", aliases: ["dancing_men"]},
  {data: "🚶‍♀", category: "Peoples", aliases: ["walking_woman"]},
  {data: "🚶", category: "Peoples", aliases: ["walking_man", "walking"]},
  {data: "🏃‍♀", category: "Peoples", aliases: ["running_woman"]},
  {data: "🏃", category: "Peoples", aliases: ["running_man", "runner", "running"]},
  {data: "👫", category: "Peoples", aliases: ["couple"]},
  {data: "👭", category: "Peoples", aliases: ["two_women_holding_hands"]},
  {data: "👬", category: "Peoples", aliases: ["two_men_holding_hands"]},
  {data: "💑", category: "Peoples", aliases: ["couple_with_heart_woman_man", "couple_with_heart"]},
  {data: "👩‍❤️‍👩", category: "Peoples", aliases: ["couple_with_heart_woman_woman"]},
  {data: "👨‍❤️‍👨", category: "Peoples", aliases: ["couple_with_heart_man_man"]},
  {data: "💏", category: "Peoples", aliases: ["couplekiss_man_woman"]},
  {data: "👩‍❤️‍💋‍👩", category: "Peoples", aliases: ["couplekiss_woman_woman"]},
  {data: "👨‍❤️‍💋‍👨", category: "Peoples", aliases: ["couplekiss_man_man"]},
  {data: "👪", category: "Peoples", aliases: ["family_man_woman_boy", "family"]},
  {data: "👨‍👩‍👧", category: "Peoples", aliases: ["family_man_woman_girl"]},
  {data: "👨‍👩‍👧‍👦", category: "Peoples", aliases: ["family_man_woman_girl_boy"]},
  {data: "👨‍👩‍👦‍👦", category: "Peoples", aliases: ["family_man_woman_boy_boy"]},
  {data: "👨‍👩‍👧‍👧", category: "Peoples", aliases: ["family_man_woman_girl_girl"]},
  {data: "👩‍👩‍👦", category: "Peoples", aliases: ["family_woman_woman_boy"]},
  {data: "👩‍👩‍👧", category: "Peoples", aliases: ["family_woman_woman_girl"]},
  {data: "👩‍👩‍👧‍👦", category: "Peoples", aliases: ["family_woman_woman_girl_boy"]},
  {data: "👩‍👩‍👦‍👦", category: "Peoples", aliases: ["family_woman_woman_boy_boy"]},
  {data: "👩‍👩‍👧‍👧", category: "Peoples", aliases: ["family_woman_woman_girl_girl"]},
  {data: "👨‍👨‍👦", category: "Peoples", aliases: ["family_man_man_boy"]},
  {data: "👨‍👨‍👧", category: "Peoples", aliases: ["family_man_man_girl"]},
  {data: "👨‍👨‍👧‍👦", category: "Peoples", aliases: ["family_man_man_girl_boy"]},
  {data: "👨‍👨‍👦‍👦", category: "Peoples", aliases: ["family_man_man_boy_boy"]},
  {data: "👨‍👨‍👧‍👧", category: "Peoples", aliases: ["family_man_man_girl_girl"]},
  {data: "👩‍👦", category: "Peoples", aliases: ["family_woman_boy"]},
  {data: "👩‍👧", category: "Peoples", aliases: ["family_woman_girl"]},
  {data: "👩‍👧‍👦", category: "Peoples", aliases: ["family_woman_girl_boy"]},
  {data: "👩‍👦‍👦", category: "Peoples", aliases: ["family_woman_boy_boy"]},
  {data: "👩‍👧‍👧", category: "Peoples", aliases: ["family_woman_girl_girl"]},
  {data: "👨‍👦", category: "Peoples", aliases: ["family_man_boy"]},
  {data: "👨‍👧", category: "Peoples", aliases: ["family_man_girl"]},
  {data: "👨‍👧‍👦", category: "Peoples", aliases: ["family_man_girl_boy"]},
  {data: "👨‍👦‍👦", category: "Peoples", aliases: ["family_man_boy_boy"]},
  {data: "👨‍👧‍👧", category: "Peoples", aliases: ["family_man_girl_girl"]},
  {data: "👚", category: "Peoples", aliases: ["womans_clothes"]},
  {data: "👕", category: "Peoples", aliases: ["shirt", "tshirt"]},
  {data: "👖", category: "Peoples", aliases: ["jeans"]},
  {data: "👔", category: "Peoples", aliases: ["necktie"]},
  {data: "👗", category: "Peoples", aliases: ["dress"]},
  {data: "👙", category: "Peoples", aliases: ["bikini"]},
  {data: "👘", category: "Peoples", aliases: ["kimono"]},
  {data: "👠", category: "Peoples", aliases: ["high_heel"]},
  {data: "👡", category: "Peoples", aliases: ["sandal"]},
  {data: "👢", category: "Peoples", aliases: ["boot"]},
  {data: "👞", category: "Peoples", aliases: ["mans_shoe", "shoe"]},
  {data: "👟", category: "Peoples", aliases: ["athletic_shoe"]},
  {data: "👒", category: "Peoples", aliases: ["womans_hat"]},
  {data: "🎩", category: "Peoples", aliases: ["tophat"]},
  {data: "🎓", category: "Peoples", aliases: ["mortar_board"]},
  {data: "👑", category: "Peoples", aliases: ["crown"]},
  {data: "⛑", category: "Peoples", aliases: ["rescue_worker_helmet"]},
  {data: "🎒", category: "Peoples", aliases: ["school_satchel"]},
  {data: "👝", category: "Peoples", aliases: ["pouch"]},
  {data: "👛", category: "Peoples", aliases: ["purse"]},
  {data: "👜", category: "Peoples", aliases: ["handbag"]},
  {data: "💼", category: "Peoples", aliases: ["briefcase"]},
  {data: "👓", category: "Peoples", aliases: ["eyeglasses"]},
  {data: "🕶", category: "Peoples", aliases: ["dark_sunglasses"]},
  {data: "🌂", category: "Peoples", aliases: ["closed_umbrella"]},
  {data: "☂️", category: "Peoples", aliases: ["open_umbrella"]}
]